/*
 * Hardstone V3 skin behaviour. Additive: wraps the live cart drawer instead of
 * replacing it, so quantity/remove/section-rendering/focus-trap stay the theme's.
 *  - "Sepete eklendi" title + check marker on the line that was just added
 *  - cart sheet motion: bottom sheet on mobile with staged content + swipe-down to dismiss
 */
(() => {
  'use strict';
  const mobile = matchMedia('(max-width: 749px)');

  // 1) Sepet çekmecesi hareketi: mobilde alttan açılan sayfa (bottom sheet), masaüstünde sağdan panel.
  //    Tek eğri ailesi: giriş "yavaşlayarak yerine oturur", çıkış "hızlanarak çekilir".
  //    İçerik (başlık, ilk ürünler, alt bölüm) panel yerine otururken sırayla yükselir. Yalnızca açılışta çalışır;
  //    sepet güncellenince (adet değişimi) yeniden oynamaz.
  const OPEN_EASE = 'cubic-bezier(.32, .72, 0, 1)';
  const CLOSE_EASE = 'cubic-bezier(.5, 0, .75, 0)';
  const RISE_EASE = 'cubic-bezier(.22, 1, .36, 1)';
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const riseTargets = (panel) => [panel.querySelector('.drawer__header'), panel.querySelector('hs-cart-shipping-progress'), ...Array.from(panel.querySelectorAll('.cart-item')).slice(0, 6), panel.querySelector('.drawer__footer')].filter(Boolean);
  const wrapMotion = () => {
    const motion = window.HardstoneMotion;
    if (!motion || motion.__hs3) return !!motion;
    const original = motion.panel.bind(motion);
    motion.panel = (panel, overlay, opts = {}) => {
      if (!panel || !panel.closest || !panel.closest('cart-drawer') || !panel.animate) return original(panel, overlay, opts);
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return [];
      const opening = opts.phase === 'enter';
      const axis = mobile.matches ? 'Y' : 'X';
      const hidden = 'translate' + axis + '(100%)';
      const f = String(opts.from || '');
      const from = !f || f.indexOf('translate') === 0 ? hidden : f; // matrix(...) = animasyon ortasından devam
      const ms = opening ? 620 : 300;
      const effects = [panel.animate([{ transform: from }, { transform: opening ? 'translate' + axis + '(0)' : hidden }], { duration: ms, easing: opening ? OPEN_EASE : CLOSE_EASE, fill: opening ? 'none' : 'forwards' })];
      if (overlay && overlay.animate) effects.push(overlay.animate([{ opacity: opts.overlayFrom }, { opacity: opening ? 1 : 0 }], { duration: opening ? 460 : 280, easing: opening ? 'ease-out' : 'ease-in', fill: opening ? 'none' : 'forwards' }));
      if (opening) {
        const dr = panel.closest('cart-drawer'); if (dr) dr.__hs3OpenAt = performance.now();
        if (!dr.hasAttribute('data-hs3-loading')) riseTargets(panel).forEach((el, i) => effects.push(el.animate([{ opacity: 0, transform: 'translateY(18px)' }, { opacity: 1, transform: 'none' }], { duration: 520, delay: 170 + i * 48, easing: RISE_EASE, fill: 'backwards' })));
      }
      return effects;
    };
    motion.__hs3 = true;
    return true;
  };
  if (!wrapMotion()) document.addEventListener('DOMContentLoaded', wrapMotion);

  // 1b) Parmakla aşağı çekerek kapatma (mobil): başlık / tutamaç bölgesinden sürüklenir.
  //     Yeterince çekilirse (110px ya da hızlı çekiş) çekmece kendi çıkış animasyonuyla kapanır, yoksa geri oturur.
  customElements.whenDefined('cart-drawer').then(() => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__hs3Drag) return;
    drawer.__hs3Drag = true;
    let y0 = 0, dy = 0, t0 = 0, active = false, panel = null, overlay = null;
    const reset = () => { if (panel) { panel.style.transform = ''; panel.style.transition = ''; } if (overlay) overlay.style.opacity = ''; };
    drawer.addEventListener('touchstart', (e) => {
      if (!mobile.matches || !drawer.classList.contains('active') || drawer.closing) return;
      panel = drawer.querySelector('.drawer__inner'); overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (!panel || !e.touches[0]) return;
      const top = panel.getBoundingClientRect().top;
      if (!e.target.closest('.drawer__header') && e.touches[0].clientY - top > 36) return;
      if (e.target.closest('.drawer__close')) return;
      active = true; y0 = e.touches[0].clientY; dy = 0; t0 = Date.now();
      panel.style.transition = 'none';
    }, { passive: true });
    drawer.addEventListener('touchmove', (e) => {
      if (!active || !e.touches[0]) return;
      const raw = e.touches[0].clientY - y0;
      dy = raw > 0 ? raw : raw / 6; // yukarı çekerken direnç
      panel.style.transform = 'translateY(' + dy + 'px)';
      if (overlay) overlay.style.opacity = String(Math.max(0, 1 - Math.max(0, dy) / (panel.offsetHeight || 600)));
    }, { passive: true });
    const end = () => {
      if (!active) return;
      active = false;
      const v = dy / Math.max(1, Date.now() - t0);
      if (dy > 110 || (dy > 40 && v > 0.55)) {
        const p = panel, o = overlay;
        drawer.close(); // başlangıç konumunu eşzamanlı okur, sonra satır içi stili temizleriz
        if (p) { p.style.transform = ''; p.style.transition = ''; }
        if (o) o.style.opacity = '';
      } else {
        const from = dy;
        reset();
        if (from > 1 && panel.animate) panel.animate([{ transform: 'translateY(' + from + 'px)' }, { transform: 'translateY(0)' }], { duration: 380, easing: OPEN_EASE });
      }
    };
    drawer.addEventListener('touchend', end, { passive: true });
    drawer.addEventListener('touchcancel', end, { passive: true });
  });

  // 2) "Sepete eklendi" state
  customElements.whenDefined('cart-drawer').then(() => {
    const Drawer = customElements.get('cart-drawer');
    if (Drawer.prototype.__hs3) return;
    Drawer.prototype.__hs3 = true;

    // product-form re-fetches the drawer section right after add, which wipes
    // anything we mark; keep re-applying the marker while the drawer is in "added" state.
    const mark = (drawer) => {
      const id = drawer.__hs3Variant;
      if (!id) return;
      const input = drawer.querySelector('[data-quantity-variant-id="' + id + '"]');
      const row = input && input.closest('.cart-item');
      if (row && !row.classList.contains('hs3-is-new')) row.classList.add('hs3-is-new');
    };
    const renderContents = Drawer.prototype.renderContents;
    Drawer.prototype.renderContents = function (state) {
      const run = () => {
        const wasLoading = this.hasAttribute('data-hs3-loading');
        const oldPanel = this.querySelector('.drawer__inner');
        const oldH = oldPanel ? oldPanel.offsetHeight : 0;
        try { renderContents.call(this, state); } finally { this.removeAttribute('data-hs3-loading'); clearTimeout(this.__hs3LoadT); }
        this.setAttribute('data-hs3-added', '');
        this.__hs3Variant = state && (state.variant_id || state.id);
        mark(this);
        if (!this.__hs3Observer) {
          this.__hs3Observer = new MutationObserver(() => { if (this.hasAttribute('data-hs3-added')) mark(this); });
          this.__hs3Observer.observe(this, { childList: true, subtree: true });
        }
        // İçerik, yükleniyor iskeletinin yerine sırayla belirir.
        const panel = this.querySelector('.drawer__inner');
        // İskelet yüksekliğinden gerçek içerik yüksekliğine yumuşak geçiş (panel zıplamasın).
        if (wasLoading && panel && panel.animate && !reduced() && mobile.matches) {
          const newH = panel.offsetHeight;
          if (oldH && Math.abs(oldH - newH) > 8) panel.animate([{ height: oldH + 'px' }, { height: newH + 'px' }], { duration: 420, easing: OPEN_EASE });
        }
        if (wasLoading && panel && panel.animate && !reduced()) riseTargets(panel).forEach((el, i) => el.animate([{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'none' }], { duration: 420, delay: i * 45, easing: RISE_EASE, fill: 'backwards' }));
      };
      // Yanıt, sheet daha yerine oturmadan gelirse kısa süre bekle: panel ortada kesilip zıplamasın.
      const wait = this.hasAttribute('data-hs3-loading') && this.__hs3OpenAt ? Math.max(0, 660 - (performance.now() - this.__hs3OpenAt)) : 0;
      if (wait > 0) setTimeout(run, wait); else run();
    };

    const open = Drawer.prototype.open;
    Drawer.prototype.open = function (triggeredBy) {
      if (triggeredBy) { this.removeAttribute('data-hs3-added'); this.__hs3Variant = null; this.querySelectorAll('.hs3-is-new').forEach((n) => n.classList.remove('hs3-is-new')); }
      return open.apply(this, arguments);
    };

    // Changing quantity / removing a line means it is no longer "just added".
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event && event.source === 'cart-items') { const d = document.querySelector('cart-drawer'); if (d) { d.removeAttribute('data-hs3-added'); d.__hs3Variant = null; d.querySelectorAll('.hs3-is-new').forEach((n) => n.classList.remove('hs3-is-new')); } }
      });
    }
  });

  // 3) Anında geri bildirim: "Sepete ekle"ye basılır basılmaz sheet açılır (iskelet görünür),
  //    ürün sepete eklenince içerik yerine gelir. Ağ yavaşken bile dokunuş "çalıştı" hissi verir.
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    const pf = form.closest('product-form');
    if (!pf || pf.closest('quick-add-modal')) return;
    const btn = pf.querySelector('[type="submit"]');
    if (!btn || btn.name !== 'add' || btn.getAttribute('aria-disabled') === 'true') return;
    const d = document.querySelector('cart-drawer');
    if (!d || d.classList.contains('active') || typeof d.open !== 'function') return;
    d.setAttribute('data-hs3-loading', '');
    d.open();
    clearTimeout(d.__hs3LoadT);
    d.__hs3LoadT = setTimeout(() => { if (d.hasAttribute('data-hs3-loading')) { d.removeAttribute('data-hs3-loading'); d.close(); } }, 12000);
  }, true);
  customElements.whenDefined('cart-drawer').then(() => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartError) {
      subscribe(PUB_SUB_EVENTS.cartError, () => {
        const d = document.querySelector('cart-drawer');
        if (d && d.hasAttribute('data-hs3-loading')) { d.removeAttribute('data-hs3-loading'); clearTimeout(d.__hs3LoadT); d.close(); }
      });
    }
  });
})();

// Atlas başlık: ana sayfada hero bitene kadar şeffaf, sonra krem zemin (body.hs-hd-sc)
(() => {
  const body = document.body;
  const hdr = () => document.querySelector('sticky-header');
  const over = body.classList.contains('hs-hd-over');
  let queued = false;
  const update = () => {
    queued = false;
    const h = hdr(); if (!h) return;
    const hero = over ? document.querySelector('hardstone-hero') : null;
    const lim = hero ? hero.offsetHeight - h.offsetHeight - 40 : 4;
    body.classList.toggle('hs-hd-sc', window.scrollY > lim);
  };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
  const setVar = () => { const h = hdr(); if (h) document.documentElement.style.setProperty('--header-height', h.offsetHeight + 'px'); };
  addEventListener('load', setVar); addEventListener('resize', setVar, { passive: true }); addEventListener('pageshow', setVar);
  document.addEventListener('DOMContentLoaded', setVar);
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  addEventListener('pageshow', schedule);
  document.addEventListener('DOMContentLoaded', schedule);
  schedule();
})();
